import { useCallback } from 'react';

import { useSelector } from 'react-redux';

import Global from '../../store/global-selectors';
import { getRateBrowserDefaults } from '../app-header/rate-browser-button';
import { useTrackWorkflow } from '../../tracking/use-workflow-tracking';
import { Workflows } from '../../tracking/tracking-constants';

export const useTrackRateBrowser = () => {
  const trackEvent = useTrackWorkflow(Workflows.RATE_BROWSER_FLOW);
  const planName = useSelector(Global.selectSellerPlanName);
  const rateBrowserDefaults = useSelector((state) => getRateBrowserDefaults(state));

  return useCallback(
    (eventType, metadata = {}) => {
      const fullMetadata = {
        ...metadata,
        planName,
        rateBrowserDefaults,
      };
      trackEvent(eventType, fullMetadata);
    },
    [planName, rateBrowserDefaults, trackEvent],
  );
};
